import * as Cookies from 'js-cookie'
import * as CryptoJS from 'crypto-js'
import env from './env'

const passPhrase = env('LOON_PASSPHRASE') || ''

/**
 * Cookie keys are; _loon_tokid(token id) | _loon_usrid(user id)
 * @param key
 * @param value
 * @param expires
 */
export const setCookie = (key: string, value: string, expires = 7) => {
  const cipheredValue = CryptoJS.AES.encrypt(value, passPhrase).toString()

  if (env('LOON_ENV') === 'development') {
    Cookies.set(key, cipheredValue)
    return
  }

  if (env('LOON_ENV') === 'staging') {
    Cookies.set(key, cipheredValue)
    return
  }

  const options: Cookies.CookieAttributes = {
    expires: expires,
    sameSite: 'Lax',
    secure: true,
  }

  Cookies.set(key, cipheredValue, options)
}
